import React from 'react';
import Form from 'components/form';
import { Container } from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form/components/upload-file-form/style';
import {
  FileInput,
  Header,
  NameTextInput,
} from 'routes/surface/components/node-modal-form/style';
import { UploadFormWrapper } from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form/components/upload-file-form/style';
import { useTranslation } from 'i18n';
import { mixed, object, string } from 'yup';

export interface UploadFileFormProps {
  accept?: string[];
  onFileChange: Function;
  onNameChange: Function;
  onCancel: Function;
  onSubmit: any;
}

const defaultProps = {
  accept: ['jpg', 'jpeg', 'png', 'pdf', 'mp4'],
};

function createValidationSchema(t) {
  return function () {
    return object().shape({
      name: string().required(t('name is required')),
      file: mixed().required(t('file is required')),
    });
  };
}

function UploadFileForm(props: UploadFileFormProps) {
  const { t } = useTranslation();

  const validationSchema = React.useMemo(createValidationSchema(t), []);

  return (
    <Form
      initialValues={{ file: null }}
      validationSchema={validationSchema}
      onSubmit={props.onSubmit}>
      {(form) => (
        <Container>
          <Header>
            <Form.Button
              label={t('Close')}
              onClick={props.onCancel}
              secondary
            />
            <Form.SubmitButton
              label={t('Insert document')}
              onClick={form.handleSubmit}
            />
          </Header>
          <UploadFormWrapper>
            <NameTextInput
              onChange={props.onNameChange}
              autoFocus
              name="name"
              placeholder={t('Name of document')}
              noBorder
              secondary
            />
            <FileInput
              name="file"
              onChange={props.onFileChange}
              label={t('Select or drag {{types}} file', {
                replace: { types: props.accept?.join(', ') },
              })}
              $hasFile={form.values.file}
              accept={props.accept}
            />
          </UploadFormWrapper>
        </Container>
      )}
    </Form>
  );
}

UploadFileForm.defaultProps = defaultProps;

export default UploadFileForm;
